<template>
  <div class="dashboard">
    <h2 class="page__title">나의 기록</h2>
    <listCom />
  </div>
</template>

<script>
import listCom from '../components/listCom.vue'

export default {
  name: 'afterLogin',
  components: { listCom },
}
</script>

<style scoped>
.dashboard {
  padding-bottom: 4rem;
}
</style>
